import {observer} from "mobx-react-lite";
import {
    FormContainer, FormContentContainer, FormStep,
    FormStepsContainer,
    HeaderContainer,
    HeaderSubtitle,
    HeaderTitle
} from "../components/decorations";
import {createContext, useContext, useEffect, useMemo} from "react";
import {FormMladiVoznikS1} from "./form_mladi_voznik_s1";
import {FormMladiVoznikS2} from "./form_mladi_voznik_s2";
import {FormMladiVoznikS3} from "./form_mladi_voznik_s3";
import {MladiVoznikStore} from "../../stores/mladi_voznik_store";
import {ApiContext, AuthStoreContext, FormStoreContext} from "../../index";
import {FormMladiVoznikS4} from "./form_mladi_voznik_s4";
import {FormMladiVoznikS5} from "./form_mladi_voznik_s5";
import {FormMladiVoznikS6} from "./form_mladi_voznik_s6";
import {FormMladiVoznikStepChildren} from "./form_mladi_voznik_step_children";
import {FormStore} from "../../stores/form_store";
import {ReservationTimer} from "../components/reservation_timer";

export const MladiVoznikStoreContext = createContext<MladiVoznikStore | null>(null);

export const FormMladiVoznik = () => {
    const api = useContext(ApiContext)
    const formStore = useContext(FormStoreContext) as FormStore;
    const store = useMemo(() => new MladiVoznikStore(api, formStore), [api, formStore])
    useEffect(() => () => store.dispose(), [store]);

    return <MladiVoznikStoreContext.Provider value={store}>
        <FormMladiVoznikContent/>
    </MladiVoznikStoreContext.Provider>
}

const FormMladiVoznikContent = observer(() => {
    const formStore = useContext(FormStoreContext) as FormStore;
    const auth = useContext(AuthStoreContext);
    return <FormContainer style={{margin: auth.authenticated ? '0' : '0 auto 0 auto'}}>
        <HeaderContainer $headerImageUrl={formStore.formConfig?.headerImageUrl}>
            <ReservationTimer/>
            <HeaderTitle>Prijava</HeaderTitle>
            <HeaderSubtitle>{formStore.meta?.tecaj?.tecajName}</HeaderSubtitle>
        </HeaderContainer>
        <Content/>
    </FormContainer>;
});

const Content = observer((props) => {
    const store = useContext(MladiVoznikStoreContext) as MladiVoznikStore;
    const formStore = useContext(FormStoreContext) as FormStore;
    const steps = [0, 1, 2, 3, 4, 5, 6].filter((i) => !store.configStepList[i]?.hide);
    return <>
        <FormStepsContainer style={{
            pointerEvents: store.formStore?.paymentInitiated ? 'none' : 'auto',
            opacity: store.formStore?.paymentInitiated ? '0' : '1',
            transition: 'all 300ms'
        }}>
            {!formStore.cardPaymentDone && steps.map((v, i) => {
                    const disabled = store.form.step1?.children && store.form.step1!.children > 0 ?
                        store.form.step1?.children! > store.step2.freePlaces! : false;
                    return <FormStep key={`form-step-${i}`} selected={store.step === v}
                                     onClick={() => {
                                         if (!disabled || i <= 1) {
                                             store.setStep(v)
                                         }
                                     }} disabled={disabled && i > 1}>
                        {i + 1}
                    </FormStep>
                }
            )
            }
        </FormStepsContainer>
        <FormContentContainer step={store.step}>
            <FormMladiVoznikS1/>
            <FormMladiVoznikS2/>
            <FormMladiVoznikStepChildren/>
            <FormMladiVoznikS3/>
            <FormMladiVoznikS4/>
            <FormMladiVoznikS5/>
            <FormMladiVoznikS6/>
        </FormContentContainer>
    </>;
});

